import { useEffect, useState, FC } from 'react';
import classnames from 'classnames';

import { IconColor, ChevronScaleSmallKindUp, ChevronScaleSmallKindDown } from 'bloko/blocks/icon';

import Badge from 'src/components/Badge';
import { useSelector } from 'src/modules/useSelector';
import sendAnalytics from 'src/utils/analytics';

import MenuLink from 'src/components/Menu/MenuLink';
import { hasActiveChild, MenuItemWithSubItems, MenuItemWithUrl } from 'src/components/Menu/utils';

import styles from 'src/components/Menu/menu.less';

const MenuGroup: FC<MenuItemWithSubItems> = ({ name, text, items, badge }) => {
    const pageName = useSelector(({ request }) => request.pageName);
    const [showSubItems, setShowSubItems] = useState(false);

    useEffect(() => {
        const isActive = hasActiveChild(items, pageName);
        if (isActive) {
            setShowSubItems(isActive);
        }
    }, [items, pageName]);

    const onClickGroupName = () => {
        setShowSubItems(!showSubItems);
        sendAnalytics.menuListToggle(name);
    };

    const Icon = showSubItems ? ChevronScaleSmallKindUp : ChevronScaleSmallKindDown;

    return (
        <>
            <div
                className={classnames(styles.menuGroupName, {
                    [styles.menuGroupNameActive]: showSubItems,
                })}
                onClick={onClickGroupName}
                data-qa="menu-group-name"
            >
                {text}
                {badge && <Badge kind={badge} />}{' '}
                <span className={styles.menuGroupNameIcon}>
                    <Icon initial={IconColor.Gray80} />
                </span>
            </div>
            {showSubItems && (
                <ul className={styles.menuList}>
                    {items.map((itemLevel2, index) => (
                        <li key={index} className={styles.menuItem} data-qa="menu-item">
                            <MenuLink {...(itemLevel2 as MenuItemWithUrl)} level={2} />
                        </li>
                    ))}
                </ul>
            )}
        </>
    );
};

export default MenuGroup;
